import ReactDOMServer from 'react-dom/server';

export function getDomParser(str) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, 'text/html');
  return doc.body.textContent || '';
}

export function getTextFromReactNode(node) {
  const htmlString = ReactDOMServer.renderToStaticMarkup(node);
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  return doc.body.textContent || '';
}
